import { get } from "lodash";
import { PAYMENT_STATUS, RUN_STATUSES, SCREEN_EVENTS } from "utils/constants";

export const PAYMENT_RESUME_TOKEN_PREFIX = "payment:";
export const MAX_SILENT_PROCESSING_HOPS = 3;

export const paymentResumeToken = (projectId) =>
  `${PAYMENT_RESUME_TOKEN_PREFIX}${projectId}`;

export const isPaidScreenEvent = (data) =>
  get(data, "source") === SCREEN_EVENTS.SOURCE &&
  get(data, "type") === SCREEN_EVENTS.TYPES.PAYMENT &&
  String(get(data, "status") || "").toUpperCase() === PAYMENT_STATUS.PAID;

export const shouldPollAwaitingRun = ({ status } = {}) =>
  status === RUN_STATUSES.AWAITING;

const CONTINUABLE_CHILD_STATUSES = [
  RUN_STATUSES.RUNNING,
  RUN_STATUSES.AWAITING,
];

const recencyValue = (item) => {
  const parsed = Date.parse(
    get(item, "createdDate") || get(item, "updatedDate") || "",
  );
  return Number.isNaN(parsed) ? 0 : parsed;
};

const nodeOrder = (item) => {
  const parsed = parseInt(get(item, "currentNode.order"), 10);
  return Number.isNaN(parsed) ? -1 : parsed;
};

const lastByProgress = (items) =>
  [...items]
    .sort((left, right) => {
      const orderDelta = nodeOrder(left) - nodeOrder(right);
      if (orderDelta !== 0) return orderDelta;
      const delta = recencyValue(left) - recencyValue(right);
      if (delta !== 0) return delta;
      return String(get(left, "id") || "").localeCompare(
        String(get(right, "id") || ""),
      );
    })
    .pop();

export const pickAutoContinueChild = (run, options = {}) => {
  if (get(run, "status") !== RUN_STATUSES.COMPLETED) return null;
  const children = (get(run, "children") || []).filter((child) =>
    CONTINUABLE_CHILD_STATUSES.includes(get(child, "status")),
  );
  if (!children.length) return null;
  const subscriptionId = options.subscriptionId;
  const matching = subscriptionId
    ? children.filter((child) => get(child, "subjectId") === subscriptionId)
    : [];
  return lastByProgress(matching.length ? matching : children);
};

export const isSilentProcessingNode = (run) => {
  if (get(run, "status") !== RUN_STATUSES.RUNNING) return false;
  const node = get(run, "currentNode");
  if (!node) return false;
  const hasScreen = (get(node, "screens") || []).some(
    (screen) => screen && screen.currentPublishedVersion,
  );
  const fields = get(node, "formDefinition.fields") || [];
  return !hasScreen && fields.length === 0;
};
